<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-htk">
    <main class="tpl-htk__main">
      <header class="tpl-htk__header">
        <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-htk__logo" />
      </header>
      <hr class="tpl-htk__divider" />

      <div v-if="showHero" class="tpl-htk__hero">
        <h1 class="tpl-htk__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-htk__hero-sub">
          <span class="tpl-htk__hero-timer" aria-hidden="true">&#9201;</span>
          {{ quiz.sub_title }}
        </p>
      </div>

      <slot />

      <footer class="tpl-htk__footer">
        <p v-if="quiz.privacy_url">
          <a :href="quiz.privacy_url" target="_blank">{{ quiz.privacy_text || 'Privacy Policy' }}</a>
        </p>
        <p v-if="quiz.legal_name" class="tpl-htk__footer-legal">
          {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
        </p>
        <p v-if="quiz.disclaimer" class="tpl-htk__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </main>
  </div>
</template>
